import React from 'react';

const SearchIcon: React.FC = () => (
  <svg width="1.1875em" height="1em" viewBox="0 0 19 16" fill="none">
    <path
      d="M9.26458 12.6667C12.2031 12.6667 14.5853 10.2789 14.5853 7.33333C14.5853 4.38781 12.2031 2 9.26458 2C6.32602 2 3.94385 4.38781 3.94385 7.33333C3.94385 10.2789 6.32602 12.6667 9.26458 12.6667Z"
      stroke="#A1AFC5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.917 14.0001L13.0238 11.1001"
      stroke="#A1AFC5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default SearchIcon;
